import { render, staticRenderFns } from "./OrderCheckoutList.vue?vue&type=template&id=21ab253f"
import script from "./OrderCheckoutList.vue?vue&type=script&lang=js"
export * from "./OrderCheckoutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports